// Autogenerated file
export const genericVehicleTypesEnum = {
    Car: "Car",
    Trailer: "Trailer",
};
export const genericVehicleTypes = [
    { label: "Машина", value: "Car" },
    { label: "Прицеп", value: "Trailer" },
];
